module.exports = __webpack_public_path__ + "img/dataMigration.3dbd9971.png";